import axios from 'axios';

// Force the API host to https so CORS preflight requests are not redirected
// (http://  or protocol-relative //  -> https://). A redirect on a preflight
// request is rejected by the browser.
function toHttps(host) {
  if (!host) return host;
  return host
    .trim()
    .replace(/^http:\/\//i, 'https://')
    .replace(/^\/\//, 'https://');
}

export function HTTP_FILES(token) {
  return axios.create({
    baseURL: toHttps(window.process.env.API_HOST_GLOBAL),
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data'
    }
  });
}




// WEBPACK FOOTER //
// ./src/core/http/http-file-common.js